export const defaultPageConfig = {
  showTotal: (total: any) => `共 ${total} 条`,
  showSizeChanger: false,
  showQuickJumper: false,
  pageSizeOptions: ['10', '20', '30', '40'],
  total: 0,
  showLessItems: true,
  size: 'small',
  pageSize: 20,
};

// 基础、多选表格...
export const dataSource = [...Array(25)].map((_, index) => {
  return {
    keshi: `${index}xx科`,
    key: (Math.random() * 100).toFixed(0) + index,
    account: '29386485620' + index,
    name: '张三' + index,
    id: (Math.random() * 100).toFixed(0) + index,
    hospital:
      Number((Math.random() * 100).toFixed(0)) > 50 ? '杭州市第一人民医院反对反对反对反对法士大夫的说法是' : '儿童医院',
    ks: '科室-' + Math.floor(Math.random() * 10) + '-' + index,
    role: '角色' + index,
    bah: '83746' + index,
    diseaseGroupName: '中医病种',
  };
});

// 子表格
export const dataSourceTree = [...Array(25)].map((_, index) => {
  return {
    key: (Math.random() * 100).toFixed(0) + index,
    account: '29386485620' + index,
    name: '张三' + index,
    rowId: (Math.random() * 100).toFixed(0) + index,
    hospital:
      Number((Math.random() * 100).toFixed(0)) > 50 ? '杭州市第一人民医院反对反对反对反对法士大夫的说法是' : '儿童医院',
    ks: '科室-' + Math.floor(Math.random() * 10) + '-' + index,
    role: '角色' + index,
    bah: '83746' + index,
    children: [
      {
        key: `${index}-0`,
        account: '29386485621' + index,
        name: `李四${index}-0`,
        rowId: (Math.random() * 100).toFixed(0) + `${index}-0`,
        hospital: '杭州市第二人民医院',
        role: `角色${index}-0`,
        bah: '8374' + index,
      },
      {
        key: `${index}-1`,
        account: '29386485622' + index,
        name: `李四${index}-1`,
        rowId: (Math.random() * 100).toFixed(0) + `${index}-1`,
        hospital: '杭州市第一人民医院反对反对反对反对法士大夫的说法是',
        role: `角色${index}-1`,
        bah: '8375' + index,
      },
    ],
  };
});
